$(document).ready(function() {
    $('img[src="https://sync.intentiq.com/profiles_engine/ProfilesEngineServlet?at=20&mi=10&secure=1&dpi=359446293&rnd=913945&pid=72oDmXJqNq&dbsaved=true&iiqidtype=2&iiqpcid=1ca63c4d-7d40-4d68-a3c1-ed48c9a9c177&iiqpciddate=1720616571613&tsrnd=811_1720661287685&pcid=767ce0fa-020e-4368-b621-2f2cf9fc8266-tuctd4fdb89&idtype=0&vrref=drafttop.com&jsver=5.4&abtp=100&abtg=A"]')
        .attr('alt', '');
});

$('a[href="https://www.shopify.com?utm_campaign=poweredby&utm_medium=shopify&utm_source=onlinestore"]').attr('aria-label', 'Powered by Shopify,this link will open in a new tab');

$(document).ready(function () {
  var existCondition = setInterval(function () {
      if ($('.slide.slide--custom-initial.slick-slide.slick-current.slick-active').length) {
          clearInterval(existCondition);
          runMyFunctionrmvtb();
      }
  }, 200);

  function runMyFunctionrmvtb() {
      $('.slide.slide--custom-initial.slick-slide.slick-current.slick-active').removeAttr('tabindex');
  }
});
$(document).ready(function() {
    $('[aria-label="Email"]').attr('aria-required', 'true');
});
$(document).ready(function() {
    $('#quantity').attr('aria-required', 'true');
});
$(document).ready(function() {
    $('.price__was').attr('aria-label', 'Original Price');
});
$(document).ready(function() {
    $('.tmenu_item_link').attr('role', 'button');
});
$(document).ready(function() {
    $('.shopify-payment-button__button').attr('role', 'button');
});
$(document).ready(function() {
    $('span').filter(function() {
        return $(this).html() === '&nbsp;';
    }).attr('role', 'none');
});
$(document).ready(function() {
    function setRoleAttribute() {
        $('.tmenu_item_link').attr('role', 'button');
    }

    setRoleAttribute(); // Run the function once on document ready

    // Set an interval to check and set the attribute repeatedly
    var intervalId = setInterval(function() {
        if ($('.tmenu_item_link').length) {
            setRoleAttribute();
            clearInterval(intervalId); // Clear the interval once the attribute is set
        }
    }, 100); // Check every 100 milliseconds
});


$(document).ready(function() {
    $('.tmenu_item_link').hover(
        function() {
            $(this).find('.tmenu_product_title, .tmenu_product_price').addClass('underline-hover');
        },
        function() {
            $(this).find('.tmenu_product_title, .tmenu_product_price').removeClass('underline-hover');
        }
    );
});

$(document).ready(function() {
    $('.prorw-verified-buyer').attr('role', 'button');
});

// Example for adding aria-label to a button with icon
$(document).ready(function() {
    // Select the button by its class or ID
    $('.prorw-verified-buyer').each(function() {
        // Get the text or description for screen readers
        var buttonText = "This button verifies the buyer's status";
        
        // Add aria-label attribute with the description
        $(this).attr('aria-label', buttonText);
    });
});

$(document).ready(function() {
    // Set tabindex="0" for elements with role="button"
    $('[role="button"]').attr('tabindex', '0');
    
    // Optionally, you can also handle click events for better keyboard accessibility
    $('[role="button"]').on('keydown', function(event) {
        // Trigger the click event on Enter key press
        if (event.which === 13 || event.which === 32) { // 13 is Enter, 32 is Spacebar
            $(this).click();
        }
    });
});


$(document).ready(function() {
  $('.custom-select__listbox').each(function() {
    var $listbox = $(this);
    
    // Get the value of aria-activedescendant
    var activeDescendantId = $listbox.attr('aria-activedescendant');
    
    // Check if aria-activedescendant is set to the specific ID
    if (activeDescendantId === 'annbar-localization-country-opt-0MobileNav') {
      var $activeDescendant = $('#' + activeDescendantId);
      
      // If the active descendant is not a child of the listbox, use aria-owns
      if ($activeDescendant.length && !$listbox.has($activeDescendant).length) {
        $listbox.attr('aria-owns', activeDescendantId);
      }
    }
  });
});














$(document).ready(function() {
    $('.prorw-featured-link').css('display', 'none');
});

$(document).ready(function() {
    $('.prorw-fa-star').attr('tabindex', '-1');
});

$(document).ready(function() {
    $('.prorw_splide_li').find('*').attr('tabindex', '-1');
});

$(document).ready(function() {
    // Select the image by its src attribute
    $('img[src="https://sync.intentiq.com/profiles_engine/ProfilesEngineServlet?at=20&amp;mi=1"]').attr('alt', '');
});
$(document).ready(function() {
    // Set ARIA level to 5 for .product-price--large
    $('.product-price--large').attr('role', 'heading').attr('aria-level', '2');
});


$(document).ready(function() {
    // Select the image by its src attribute
    $('img[src="https://sync.intentiq.com/profiles_engine/ProfilesEngineServlet?at=20&amp;mi=1"]').css('display', 'none');
});


$(document).ready(function() {
    // Set elements with class .prorw_review_author_last_initial to display none
    $('.prorw_review_author_last_initial').css('display', 'none');
});
$(document).ready(function() {
    $('body.template-index > img').css('display', 'none');
    $('body.template-product > img').css('display', 'none');
    $('.prorw-verified-buyer').css('display', 'none');
});

$(document).ready(function() {
  $('.prorw-featured-container > h5').css('display', 'none');
});


$(document).ready(function() {
    function setRoleAttribute() {
        $('.price__current').attr('role', 'status');
    }});

setTimeout(function() {
    $('.kl-private-reset-css-Xuajs1').attr('alt', 'Draft Top image');
}, 1900); // Adjust time based on when Klaviyo injects the element




    setTimeout(function() {
        $('.ql-font-kanit').each(function() {
            var text = $(this).text();
            $(this).html('<strong>' + text + '</strong>');
        });
    }, 500); // Delay execution by 1500 milliseconds (1.5 seconds)



$(document).ready(function() {
    // Find all elements with role="button"
    $('[role="button"]').each(function() {
        // Find all descendants with tabindex and remove tabindex attribute
        $(this).find('[tabindex]').removeAttr('tabindex');
    });
});


$(document).ready(function() {
    // Remove aria-label and aria-labelledby from <div> and <span> elements
    $('div[aria-label], div[aria-labelledby], span[aria-label], span[aria-labelledby]').removeAttr('aria-label aria-labelledby');
});

$(document).ready(function() {
    // Check if the description element exists, if not, create it
    if (!$('.new-window-warning').length) {
        $('body').append('<span class="new-window-warning visually-hidden">Opens in a new window</span>');
    }

    // Select all links with target="_blank" and add aria-describedby
    $('a[target="_blank"]').each(function() {
        $(this).attr('aria-describedby', $('.new-window-warning').attr('class'));
    });
});

$(document).ready(function() {
    // Select all links with target="_blank" and add aria-describedby and title
    $('a[target="_blank"]').each(function() {
        $(this).attr({
            'aria-describedby': $('.new-window-warning').attr('class'),
            'title': 'Opens in a new window'
        });
    });
});



// $(document).ready(function() {
//     // Check if the description element exists, if not, create it
//     if (!$('#new-window-warning').length) {
//         $('body').append('<span id="new-window-warning" class="visually-hidden">Opens in a new window</span>');
//     }

//     // Select all links with target="_blank" and add aria-describedby
//     $('a[target="_blank"]').attr('aria-describedby', 'new-window-warning');
// });
// $(document).ready(function() {
//     // Select all links with target="_blank" and add aria-describedby and title
//     $('a[target="_blank"]').attr({
//         'aria-describedby': 'new-window-warning',
//         'title': 'Opens in a new window'
//     });
// });
$(window).on('load', function() {
    $('img[src="https://arttrk.com/pixel/?ad_log=referer&action=lead&pixid=bc2e4151-1730-4d3c-9c3c-1ebeb9793910"]').attr('alt', 'pixel image');
});

 
     document.querySelectorAll('script[type="module"][defer]').forEach(script => {
    script.removeAttribute('defer');
  });
    document.addEventListener('DOMContentLoaded', function() {
  // Select all script tags
  const scriptTags = document.querySelectorAll('script[type="module"]');

  // Loop through and remove defer attribute if it exists
  scriptTags.forEach(script => {
    if (script.hasAttribute('defer')) {
      script.removeAttribute('defer');
    }
  });
});

$(document).ready(function() {
    // Wait for a short duration to ensure the app has rendered the instafeed images
    setTimeout(function() {
        // Use event delegation to target dynamically added elements
        $('.instafeed-new-layout-item-container ').each(function(index) {
            // Add the aria-label attribute dynamically
            $(this).attr('aria-label', 'Instagram feed image ' + (index + 1));
        });
    }, 1800); // Adjust this delay based on how long it takes for the app to render the images
});
;
$(document).ready(function() {
    // Function to add title attribute
    function addTitleAttribute() {
        var link = $('#shopify-pc__banner__body-policy-link');
        if (link.length) {
            link.attr('title', 'Opens in a new window');
        }
    }

    // Use setTimeout to wait for the element to be injected
    setTimeout(function() {
        addTitleAttribute();
    }, 1000); // Adjust the timeout duration as needed (1000 ms = 1 second)
});

$(document).ready(function() {
    $('.social__link').removeAttr('aria-describedby');
});


(function () {
  function ensureAlt(img) {
    if (!img || img.hasAttribute('alt')) return;
    // try common data sources or nearest original
    const candidate =
      img.getAttribute('data-alt') ||
      img.closest('[data-media-id]')?.querySelector('img[alt]')?.getAttribute('alt') ||
      img.getAttribute('title') ||
      document.querySelector('h1,h2,[data-product-title]')?.textContent?.trim();
    if (candidate != null) img.setAttribute('alt', candidate);
  }

  // initial pass
  document.querySelectorAll('img').forEach(ensureAlt);

  // watch for clones/lazy swaps
  new MutationObserver(muts => {
    for (const m of muts) {
      m.addedNodes?.forEach(n => {
        if (n.nodeType === 1) {
          if (n.tagName === 'IMG') ensureAlt(n);
          n.querySelectorAll?.('img').forEach(ensureAlt);
        }
      });
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();


